import { FC, memo } from 'react';
import i18next from 'i18next';

import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';
import PrimaryButtonLoading from '~src/shared/buttons/loadingButtons/PrimaryButtonLoading';
import { routes } from '~src/routingConfig';

import {
  ButtonContainer,
  ButtonsWrapper,
  LinkWrapper,
  ButtonLink,
  ButtonsSection,
} from './topicQuestionsForm.sc';

interface Props {
  discardChanges: () => void;
  t: i18next.TFunction;
  loadingSave: boolean;
  showSave: boolean;
  isPrivate?: boolean;
}

const ButtonSection: FC<Props> = memo(({ isPrivate, loadingSave, t, discardChanges, showSave }) => (
  <ButtonsSection>
    {!isPrivate ? (
      <LinkWrapper>
        <span data-translation="x.survey.details.topic_select.buttons.link_topic.p1">
          {t('x.survey.details.topic_select.buttons.link_topic.p1')}
        </span>
        <ButtonLink
          to={routes.contentTopics.topics}
          data-translation="x.survey.details.topic_select.buttons.link_topic.p2"
        >
          {t('x.survey.details.topic_select.buttons.link_topic.p2')}
        </ButtonLink>
      </LinkWrapper>
    ) : (
      <div />
    )}
    {showSave && (
      <ButtonsWrapper>
        <ButtonContainer>
          <SecondaryButton onClick={discardChanges}>
            <span data-translation="x.surveys.topics.button.cancel">
              {t('x.surveys.topics.button.cancel')}
            </span>
          </SecondaryButton>
        </ButtonContainer>
        <ButtonContainer>
          <PrimaryButtonLoading isLoading={loadingSave}>
            <span data-translation="x.surveys.topics.button.save">{t('x.surveys.topics.button.save')}</span>
          </PrimaryButtonLoading>
        </ButtonContainer>
      </ButtonsWrapper>
    )}
  </ButtonsSection>
));

export default ButtonSection;
